import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/store/modules/auth.js";
import * as roles from "@/store/modules/roles.js";
import * as permisos from "@/store/modules/permisos.js";
import * as users from "@/store/modules/users.js";
import * as logs from "@/store/modules/logs.js";
import * as perfil from "@/store/modules/perfil.js";
import * as magistrados from "@/store/modules/magistrados.js";
import * as salas from "@/store/modules/salas.js";
import * as tocas from "@/store/modules/tocas.js";
import * as delitos from "@/store/modules/delitos.js";
import * as tipoJuicios from "@/store/modules/tipoJuicios.js";
import * as sentidos from "@/store/modules/sentidos.js";
import * as reportesJson from "@/store/modules/reportesJson.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    roles,
    permisos,
    users,
    logs,
    perfil,
    magistrados,
    salas,
    tocas,
    delitos,
    tipoJuicios,
    sentidos,
    reportesJson,
  },
  state: {
    layout: "dashboard-layout",
    loading: false,
    notification: ""
  },
  mutations: {
    SET_NOTIFICATION(state, payload) {
      // payload = { tipo: 'success', message:'el mensaje de success'}
      state.notification = Object.assign({}, payload);
    },
    CLEAR_NOTIFICATION(state, payload) {
      state.notification = { tipo: "", message: "" };
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LAYOUT(state, newLayout) {
      state.layout = newLayout;
    }
  },
  actions: {},
  getters: {}
});
